import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M0 20C0 8.95431 8.95431 0 20 0H36C47.0457 0 56 8.95431 56 20V20C56 31.0457 47.0457 40 36 40H20C8.95431 40 0 31.0457 0 20V20Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 40

/**
 * Round rect shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const RoundRectShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default RoundRectShape
